import { render } from "./supportDetail.vue?vue&type=template&id=4ad9b061"
import script from "./supportDetail.vue?vue&type=script&lang=js"
export * from "./supportDetail.vue?vue&type=script&lang=js"

import "./supportDetail.vue?vue&type=style&index=0&id=4ad9b061&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__